import { Z3KTabId } from 'z3k-settings/utils/tab-ids';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { createSlice } from '@reduxjs/toolkit';
export const initialZ3KSettingsState = {
    open: false,
    visible: false,
    loading: false,
    device_id: null,
    isServiceView: undefined,
    activeTab: isMediumUI() ? Z3KTabId.settings : null,
    openedIds: [],
    restartDialogOpen: false,
    error_text: '',
    show_error: false,
    app_key: 1,
    action_state: {},
};
// TODO: delete reducer
export const reducer = (state = initialZ3KSettingsState, action) => {
    switch (action.type) {
        case 'OPEN_Z3K_SETTINGS':
            return {
                ...state,
                device_id: action.device_id,
                open: true,
                visible: true,
                loading: false,
                activeTab: action.activeTab,
                openedIds: action.openedIds,
                app_key: state.app_key + 1,
            };
        // case 'SELECT_DEVICE_Z3K_SETTINGS':
        //     return {
        //         ...state,
        //         device_id: action.device_id,
        //     }
        case 'CLOSE_Z3K_SETTINGS':
            return {
                ...state,
                open: false,
            };
        case 'SAVE_Z3K_SETTINGS__REQUEST':
            return { ...state, loading: true };
        case 'SAVE_Z3K_SETTINGS__OK':
            return {
                ...state,
                loading: false,
                show_error: false,
                app_key: state.app_key + 1,
            };
        case 'SAVE_Z3K_SETTINGS__FAIL':
            return {
                ...state,
                loading: false,
                error_text: action.error.error_ui ?? 'Не удалось сохранить конфигурацию',
                show_error: true,
            };
        case 'CLEAR_Z3K_SETTINGS_ERROR':
            return { ...state, show_error: false };
        case 'CLEAR_Z3K_SETTINGS':
            return { ...state, visible: false };
        case 'UPLOAD_Z3K_CONFIG__REQUEST':
            return { ...state, loading: true };
        case 'UPLOAD_Z3K_CONFIG__OK':
        case 'APPLY_STOCK_CONFIG__OK':
            return {
                ...state,
                loading: false,
                show_error: false,
                app_key: state.app_key + 1,
            };
        case 'UPLOAD_Z3K_CONFIG__FAIL':
            return {
                ...state,
                loading: false,
                error_text: action.error.error_ui ?? 'Не удалось загрузить конфигурацию',
                show_error: true,
            };
        case 'Z3K_COMMAND_SENT_TO_SERVER':
            return {
                ...state,
                action_state: {
                    ...state.action_state,
                    [action.device_id]: {
                        [action.object_id]: {
                            fail: false,
                            fail_message: '',
                            loading: true,
                        },
                    },
                },
            };
        case 'Z3K_COMMAND_SENT_TO_SERVER__OK':
            if (action.command_name === 'RestartDevice')
                return { ...state, restartDialogOpen: true };
            return {
                ...state,
                action_state: {
                    ...state.action_state,
                    [action.device_id]: {
                        [action.object_id]: {
                            fail: false,
                            fail_message: '',
                            loading: false,
                        },
                    },
                },
            };
        case 'Z3K_COMMAND_SENT_TO_SERVER__FAIL':
            return {
                ...state,
                action_state: {
                    ...state.action_state,
                    [action.device_id]: {
                        [action.object_id]: {
                            fail: true,
                            fail_message: action.error_message,
                            loading: false,
                        },
                    },
                },
            };
        case 'Z3K_COMMAND_TO_SERVER_RESET__FAIL':
            return {
                ...state,
                action_state: {
                    ...state.action_state,
                    [action.device_id]: {
                        [action.object_id]: {
                            fail: false,
                            fail_message: '',
                            loading: false,
                        },
                    },
                },
            };
        case 'CLOSE_Z3K_RESTART_DIALOG':
            return { ...state, restartDialogOpen: false };
        case 'Z3K_SET_SERVICE_VIEW':
            return { ...state, isServiceView: action.isServiceView };
        case 'Z3K_SETTINGS_SELECT_TAB':
            return { ...state, activeTab: action.activeTab };
        case 'Z3K_SETTINGS_UPDATE_OPENED_IDS':
            return { ...state, openedIds: action.openedIds };
        default:
            return state;
    }
};
// need for not send device_id every tab change via router
const slice = createSlice({
    name: 'router_device_id',
    initialState: null,
    reducers: {
        UpdateRouterDeviceId: (state, action) => action.payload,
    },
});
export const { UpdateRouterDeviceId } = slice.actions;
export const UpdateRouterDeviceIdReducer = slice.reducer;
